var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActionView = function SvgActionView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-1532 -146.791) translate(1532 146.791)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#008060",
    d: "M8.36 9.521a8.329 8.329 0 0 0 7.327-4.364 8.334 8.334 0 0 0-14.655 0A8.329 8.329 0 0 0 8.36 9.521zM8.36 0a9.126 9.126 0 0 1 8.22 5.159 9.128 9.128 0 0 1-16.438 0A9.125 9.125 0 0 1 8.36 0zm0 1.587a3.57 3.57 0 1 1-3.57 3.57 3.57 3.57 0 0 1 3.57-3.57zm0 .793a2.777 2.777 0 1 0 2.777 2.777A2.777 2.777 0 0 0 8.36 2.38z",
    transform: "translate(-1532 -146.791) translate(1535.967 154.129) translate(-.141)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-view.7e72e139.svg";
export { ForwardRef as ReactComponent };